import { TEST_NAME_MAP } from "../constants/testNameMap";

export default function DataTable({ data }) {
  const getValue = (row) => {
    if (row.raw_data !== undefined) {
      return Array.isArray(row.raw_data) ? row.raw_data.join(", ") : String(row.raw_data);
    }
    return row.data?.[0]?.data ?? "";
  };

  const getTestLabel = (row) => {
    const key = row.name_id ?? row.testid;
    return TEST_NAME_MAP[key] || key;
  };

  return (
    <table border="1" cellPadding="8">
      <thead>
        <tr>
          <th>Test Name</th>
          <th>Passed</th>
          <th>Error Code</th>
          <th>Value</th>
          <th>Time</th>
        </tr>
      </thead>

      <tbody>
        {data.map((d, i) => (
          <tr key={i}>
            <td>{getTestLabel(d)}</td>
            <td style={{ color: d.passed ? "green" : "red" }}>
              {d.passed ? "PASS" : "FAIL"}
            </td>
            <td>{d.errorcode ?? (d.critical ? 1 : 0)}</td>
            <td>{getValue(d)}</td>
            <td>{new Date(d.time).toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}